<template>
    <div class="flex w-full h-full documents-view justify-content-around">
        <LibyanOrnament vertical class="lib-or mr-5"/>
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.documentList.header') }}</h2>
            </div>
            <DocumentTable ref="documentTable" />
        </div>
    </div>
</template>

<script>
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import DocumentTable from "@/views/documents/components/DocumentTable.vue";

export default {
    name: "DocumentListView",
    components: {
        CustomButton,
        DocumentTable,
        LibyanOrnament,
    },

    data() {
        return {
        };
    },

    methods: {
        reloadTable() {
            this.$refs.documentTable.reloadTable();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/theme/mytheme/variables";
.stallions-view {
    @media screen and (max-width: 750px) {
        .lib-or {
            display: none;
        }
    }
    @media screen and (max-width: 650px) {
        padding: 0 20px;
    }
}
</style>
